:host {
  display: block;
  max-width: 100%;
  cursor: default;
}

.subtitle {
  text-transform: uppercase;
  color: var(--chart-302-icon-buttons-titles);
}

.description-text {
  opacity: 0.8;
}

.view-more-details-button {
  padding-top: calc(var(--spacer / 2));
}

gz-button[class*='inline-text'] {
  &::part(button) {
    text-align: start;
    padding: 0;
  }
}

gz-labeled-content::part(content) {
  margin-top: -2px;
}

gz-icon[class*='arrow-icon'] {
  padding-left: calc(var(--spacer) / 2);
}

.lightBold {
  font-weight: 600;
}
